module.exports = __webpack_public_path__ + "img/TW_WeChat_QR.704e5bdd.webp";